const dev = !!process.env.DEV_MODE;
export const PROTO_PATH = dev
  ? __dirname + '/../investAPI/src/docs/contracts/'
  : __dirname + '/../proto/';
